import React, { useEffect, useRef } from 'react'
import I18n from 'i18n-js'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Paper from '@material-ui/core/Paper'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import Fade from '@material-ui/core/Fade'
import { useDispatch, useSelector } from 'react-redux'
import * as SettingsAction from './SettingsAction'

import { H1, H4 } from './../../../src/components/UI/index'
import jstz from 'jstz'
// import ConsultantCard from '../ConsultantCard/ConsultantCard'
import { useParams } from 'react-router-dom'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import SettingsCard from './components/settingsCard/SettingsCard'
import TimezoneModalCard from './components/Modal/TimezoneModalCard'
import CurrencyModalCard from './components/Modal/CurrencyModalCard'
import LanguageModalCard from './components/Modal/LanguageModalCard'
import Button from '@material-ui/core/Button'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 275,
		maxWidth: 744
	},

	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		},
		language: {
			flex: 1
		}

	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	paper: {
		[theme.breakpoints.up('md')]: {
			width: 516
		},
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 2, 2),
		borderRadius: 20,
		'box-shadow': 'none',
		'&:focus': {
			outline: 'none'
		}
	},
	bottom: {
		marginTop: 40

	}
}))

const SettingsScreen = (props) => {
	const rightBox = useRef(0)

	const ttc = {
		'America/Aruba': 'AWG',
		'Asia/Kabul': 'AFN',
		'Africa/Luanda': 'AOA',
		'America/Anguilla': 'XCD',
		'Europe/Mariehamn': 'EUR',
		'Europe/Tirane': 'ALL',
		'Europe/Andorra': 'EUR',
		'Asia/Dubai': 'AED',
		'America/Argentina/Buenos_Aires': 'ARS',
		'America/Argentina/Catamarca': 'ARS',
		'America/Argentina/Cordoba': 'ARS',
		'America/Argentina/Jujuy': 'ARS',
		'America/Argentina/La_Rioja': 'ARS',
		'America/Argentina/Mendoza': 'ARS',
		'America/Argentina/Rio_Gallegos': 'ARS',
		'America/Argentina/Salta': 'ARS',
		'America/Argentina/San_Juan': 'ARS',
		'America/Argentina/San_Luis': 'ARS',
		'America/Argentina/Tucuman': 'ARS',
		'America/Argentina/Ushuaia': 'ARS',
		'Asia/Yerevan': 'AMD',
		'Pacific/Pago_Pago': 'USD',
		'Antarctica/Casey': 'USD',
		'Antarctica/Davis': 'USD',
		'Antarctica/DumontDUrville': 'USD',
		'Antarctica/Mawson': 'USD',
		'Antarctica/McMurdo': 'USD',
		'Antarctica/Palmer': 'USD',
		'Antarctica/Rothera': 'USD',
		'Antarctica/Syowa': 'USD',
		'Antarctica/Troll': 'USD',
		'Antarctica/Vostok': 'USD',
		'Indian/Kerguelen': 'EUR',
		'America/Antigua': 'XCD',
		'Antarctica/Macquarie': 'AUD',
		'Australia/Adelaide': 'AUD',
		'Australia/Brisbane': 'AUD',
		'Australia/Broken_Hill': 'AUD',
		'Australia/Currie': 'AUD',
		'Australia/Darwin': 'AUD',
		'Australia/Eucla': 'AUD',
		'Australia/Hobart': 'AUD',
		'Australia/Lindeman': 'AUD',
		'Australia/Lord_Howe': 'AUD',
		'Australia/Melbourne': 'AUD',
		'Australia/Perth': 'AUD',
		'Australia/Sydney': 'AUD',
		'Europe/Vienna': 'EUR',
		'Asia/Baku': 'AZN',
		'Africa/Bujumbura': 'BIF',
		'Europe/Brussels': 'EUR',
		'Africa/Porto-Novo': 'XOF',
		'America/Kralendijk': 'USD',
		'Africa/Ouagadougou': 'XOF',
		'Asia/Dhaka': 'BDT',
		'Europe/Sofia': 'BGN',
		'Asia/Bahrain': 'BHD',
		'America/Nassau': 'BSD',
		'Europe/Sarajevo': 'BAM',
		'America/St_Barthelemy': 'EUR',
		'Europe/Minsk': 'BYN',
		'America/Belize': 'BZD',
		'Atlantic/Bermuda': 'BMD',
		'America/La_Paz': 'BOB',
		'America/Araguaina': 'BRL',
		'America/Bahia': 'BRL',
		'America/Belem': 'BRL',
		'America/Boa_Vista': 'BRL',
		'America/Campo_Grande': 'BRL',
		'America/Cuiaba': 'BRL',
		'America/Eirunepe': 'BRL',
		'America/Fortaleza': 'BRL',
		'America/Maceio': 'BRL',
		'America/Manaus': 'BRL',
		'America/Noronha': 'BRL',
		'America/Porto_Velho': 'BRL',
		'America/Recife': 'BRL',
		'America/Rio_Branco': 'BRL',
		'America/Santarem': 'BRL',
		'America/Sao_Paulo': 'BRL',
		'America/Barbados': 'BBD',
		'Asia/Brunei': 'BND',
		'Asia/Thimphu': 'BTN',
		'Africa/Gaborone': 'BWP',
		'Africa/Bangui': 'XAF',
		'America/Atikokan': 'CAD',
		'America/Blanc-Sablon': 'CAD',
		'America/Cambridge_Bay': 'CAD',
		'America/Creston': 'CAD',
		'America/Dawson': 'CAD',
		'America/Dawson_Creek': 'CAD',
		'America/Edmonton': 'CAD',
		'America/Fort_Nelson': 'CAD',
		'America/Glace_Bay': 'CAD',
		'America/Goose_Bay': 'CAD',
		'America/Halifax': 'CAD',
		'America/Inuvik': 'CAD',
		'America/Iqaluit': 'CAD',
		'America/Moncton': 'CAD',
		'America/Nipigon': 'CAD',
		'America/Pangnirtung': 'CAD',
		'America/Rainy_River': 'CAD',
		'America/Rankin_Inlet': 'CAD',
		'America/Regina': 'CAD',
		'America/Resolute': 'CAD',
		'America/St_Johns': 'CAD',
		'America/Swift_Current': 'CAD',
		'America/Thunder_Bay': 'CAD',
		'America/Toronto': 'CAD',
		'America/Vancouver': 'CAD',
		'America/Whitehorse': 'CAD',
		'America/Winnipeg': 'CAD',
		'America/Yellowknife': 'CAD',
		'Indian/Cocos': 'AUD',
		'Europe/Zurich': 'CHE',
		'America/Punta_Arenas': 'CLF',
		'America/Santiago': 'CLF',
		'Pacific/Easter': 'CLF',
		'Asia/Shanghai': 'CNY',
		'Asia/Urumqi': 'CNY',
		'Africa/Abidjan': 'XOF',
		'Africa/Douala': 'XAF',
		'Africa/Kinshasa': 'CDF',
		'Africa/Lubumbashi': 'CDF',
		'Africa/Brazzaville': 'XAF',
		'Pacific/Rarotonga': 'NZD',
		'America/Bogota': 'COP',
		'Indian/Comoro': 'KMF',
		'Atlantic/Cape_Verde': 'CVE',
		'America/Costa_Rica': 'CRC',
		'America/Havana': 'CUC',
		'America/Curacao': 'ANG',
		'Indian/Christmas': 'AUD',
		'America/Cayman': 'KYD',
		'Asia/Famagusta': 'EUR',
		'Asia/Nicosia': 'EUR',
		'Europe/Prague': 'CZK',
		'Europe/Berlin': 'EUR',
		'Europe/Busingen': 'EUR',
		'Africa/Djibouti': 'DJF',
		'America/Dominica': 'XCD',
		'Europe/Copenhagen': 'DKK',
		'America/Santo_Domingo': 'DOP',
		'Africa/Algiers': 'DZD',
		'America/Guayaquil': 'USD',
		'Pacific/Galapagos': 'USD',
		'Africa/Cairo': 'EGP',
		'Africa/Asmara': 'ERN',
		'Africa/El_Aaiun': 'DZD',
		'Africa/Ceuta': 'EUR',
		'Atlantic/Canary': 'EUR',
		'Europe/Madrid': 'EUR',
		'Europe/Tallinn': 'EUR',
		'Africa/Addis_Ababa': 'ETB',
		'Europe/Helsinki': 'EUR',
		'Pacific/Fiji': 'FJD',
		'Atlantic/Stanley': 'FKP',
		'Europe/Paris': 'EUR',
		'Atlantic/Faroe': 'DKK',
		'Pacific/Chuuk': 'USD',
		'Pacific/Kosrae': 'USD',
		'Pacific/Pohnpei': 'USD',
		'Africa/Libreville': 'XAF',
		'Europe/London': 'GBP',
		'Asia/Tbilisi': 'GEL',
		'Europe/Guernsey': 'GBP',
		'Africa/Accra': 'GHS',
		'Europe/Gibraltar': 'GIP',
		'Africa/Conakry': 'GNF',
		'America/Guadeloupe': 'EUR',
		'Africa/Banjul': 'GMD',
		'Africa/Bissau': 'XOF',
		'Africa/Malabo': 'XAF',
		'Europe/Athens': 'EUR',
		'America/Grenada': 'XCD',
		'America/Danmarkshavn': 'DKK',
		'America/Nuuk': 'DKK',
		'America/Scoresbysund': 'DKK',
		'America/Thule': 'DKK',
		'America/Guatemala': 'GTQ',
		'America/Cayenne': 'EUR',
		'Pacific/Guam': 'USD',
		'America/Guyana': 'GYD',
		'Asia/Hong_Kong': 'HKD',
		'America/Tegucigalpa': 'HNL',
		'Europe/Zagreb': 'HRK',
		'America/Port-au-Prince': 'HTG',
		'Europe/Budapest': 'HUF',
		'Asia/Jakarta': 'IDR',
		'Asia/Jayapura': 'IDR',
		'Asia/Makassar': 'IDR',
		'Asia/Pontianak': 'IDR',
		'Europe/Isle_of_Man': 'GBP',
		'Asia/Kolkata': 'INR',
		'Indian/Chagos': 'GBP',
		'Europe/Dublin': 'EUR',
		'Asia/Tehran': 'IRR',
		'Asia/Baghdad': 'IQD',
		'Atlantic/Reykjavik': 'ISK',
		'Asia/Jerusalem': 'ILS',
		'Europe/Rome': 'EUR',
		'America/Jamaica': 'JMD',
		'Europe/Jersey': 'GBP',
		'Asia/Amman': 'JOD',
		'Asia/Tokyo': 'JPY',
		'Asia/Almaty': 'KZT',
		'Asia/Aqtau': 'KZT',
		'Asia/Aqtobe': 'KZT',
		'Asia/Atyrau': 'KZT',
		'Asia/Oral': 'KZT',
		'Asia/Qostanay': 'KZT',
		'Asia/Qyzylorda': 'KZT',
		'Africa/Nairobi': 'KES',
		'Asia/Bishkek': 'KGS',
		'Asia/Phnom_Penh': 'KHR',
		'Pacific/Enderbury': 'AUD',
		'Pacific/Kiritimati': 'AUD',
		'Pacific/Tarawa': 'AUD',
		'America/St_Kitts': 'XCD',
		'Asia/Seoul': 'KRW',
		'Asia/Kuwait': 'KWD',
		'Asia/Vientiane': 'LAK',
		'Asia/Beirut': 'LBP',
		'Africa/Monrovia': 'LRD',
		'Africa/Tripoli': 'LYD',
		'America/St_Lucia': 'XCD',
		'Europe/Vaduz': 'CHF',
		'Asia/Colombo': 'LKR',
		'Africa/Maseru': 'LSL',
		'Europe/Vilnius': 'EUR',
		'Europe/Luxembourg': 'EUR',
		'Europe/Riga': 'EUR',
		'Asia/Macau': 'MOP',
		'America/Marigot': 'EUR',
		'Africa/Casablanca': 'MAD',
		'Europe/Monaco': 'EUR',
		'Europe/Chisinau': 'MDL',
		'Indian/Antananarivo': 'MGA',
		'Indian/Maldives': 'MVR',
		'America/Bahia_Banderas': 'MXN',
		'America/Cancun': 'MXN',
		'America/Chihuahua': 'MXN',
		'America/Hermosillo': 'MXN',
		'America/Matamoros': 'MXN',
		'America/Mazatlan': 'MXN',
		'America/Merida': 'MXN',
		'America/Mexico_City': 'MXN',
		'America/Monterrey': 'MXN',
		'America/Ojinaga': 'MXN',
		'America/Tijuana': 'MXN',
		'Pacific/Kwajalein': 'USD',
		'Pacific/Majuro': 'USD',
		'Europe/Skopje': 'MKD',
		'Africa/Bamako': 'XOF',
		'Europe/Malta': 'EUR',
		'Asia/Yangon': 'MMK',
		'Europe/Podgorica': 'EUR',
		'Asia/Choibalsan': 'MNT',
		'Asia/Hovd': 'MNT',
		'Asia/Ulaanbaatar': 'MNT',
		'Pacific/Saipan': 'USD',
		'Africa/Maputo': 'MZN',
		'Africa/Nouakchott': 'MRO',
		'America/Montserrat': 'XCD',
		'America/Martinique': 'EUR',
		'Indian/Mauritius': 'MUR',
		'Africa/Blantyre': 'MWK',
		'Asia/Kuala_Lumpur': 'MYR',
		'Asia/Kuching': 'MYR',
		'Indian/Mayotte': 'EUR',
		'Africa/Windhoek': 'NAD',
		'Pacific/Noumea': 'XPF',
		'Africa/Niamey': 'XOF',
		'Pacific/Norfolk': 'AUD',
		'Africa/Lagos': 'NGN',
		'America/Managua': 'NIO',
		'Pacific/Niue': 'NZD',
		'Europe/Amsterdam': 'EUR',
		'Europe/Oslo': 'NOK',
		'Asia/Kathmandu': 'NPR',
		'Pacific/Nauru': 'AUD',
		'Pacific/Auckland': 'NZD',
		'Pacific/Chatham': 'NZD',
		'Asia/Muscat': 'OMR',
		'Asia/Karachi': 'PKR',
		'America/Panama': 'PAB',
		'Pacific/Pitcairn': 'NZD',
		'America/Lima': 'PEN',
		'Asia/Manila': 'PHP',
		'Pacific/Palau': 'USD',
		'Pacific/Bougainville': 'PGK',
		'Pacific/Port_Moresby': 'PGK',
		'Europe/Warsaw': 'PLN',
		'America/Puerto_Rico': 'USD',
		'Asia/Pyongyang': 'KPW',
		'Atlantic/Azores': 'EUR',
		'Atlantic/Madeira': 'EUR',
		'Europe/Lisbon': 'EUR',
		'America/Asuncion': 'PYG',
		'Asia/Gaza': 'ILS',
		'Asia/Hebron': 'ILS',
		'Pacific/Gambier': 'XPF',
		'Pacific/Marquesas': 'XPF',
		'Pacific/Tahiti': 'XPF',
		'Asia/Qatar': 'QAR',
		'Indian/Reunion': 'EUR',
		'Europe/Bucharest': 'RON',
		'Asia/Anadyr': 'RUB',
		'Asia/Barnaul': 'RUB',
		'Asia/Chita': 'RUB',
		'Asia/Irkutsk': 'RUB',
		'Asia/Kamchatka': 'RUB',
		'Asia/Khandyga': 'RUB',
		'Asia/Krasnoyarsk': 'RUB',
		'Asia/Magadan': 'RUB',
		'Asia/Novokuznetsk': 'RUB',
		'Asia/Novosibirsk': 'RUB',
		'Asia/Omsk': 'RUB',
		'Asia/Sakhalin': 'RUB',
		'Asia/Srednekolymsk': 'RUB',
		'Asia/Tomsk': 'RUB',
		'Asia/Ust-Nera': 'RUB',
		'Asia/Vladivostok': 'RUB',
		'Asia/Yakutsk': 'RUB',
		'Asia/Yekaterinburg': 'RUB',
		'Europe/Astrakhan': 'RUB',
		'Europe/Kaliningrad': 'RUB',
		'Europe/Kirov': 'RUB',
		'Europe/Moscow': 'RUB',
		'Europe/Samara': 'RUB',
		'Europe/Saratov': 'RUB',
		'Europe/Ulyanovsk': 'RUB',
		'Europe/Volgograd': 'RUB',
		'Africa/Kigali': 'RWF',
		'Asia/Riyadh': 'SAR',
		'Africa/Khartoum': 'SDG',
		'Africa/Dakar': 'XOF',
		'Asia/Singapore': 'SGD',
		'Atlantic/South_Georgia': 'GBP',
		'Atlantic/St_Helena': 'SHP',
		'Arctic/Longyearbyen': 'NOK',
		'Pacific/Guadalcanal': 'SBD',
		'Africa/Freetown': 'SLL',
		'America/El_Salvador': 'SVC',
		'Europe/San_Marino': 'EUR',
		'Africa/Mogadishu': 'SOS',
		'America/Miquelon': 'EUR',
		'Europe/Belgrade': 'RSD',
		'Africa/Juba': 'SSP',
		'Africa/Sao_Tome': 'STD',
		'America/Paramaribo': 'SRD',
		'Europe/Bratislava': 'EUR',
		'Europe/Ljubljana': 'EUR',
		'Europe/Stockholm': 'SEK',
		'Africa/Mbabane': 'SZL',
		'America/Lower_Princes': 'ANG',
		'Indian/Mahe': 'SCR',
		'Asia/Damascus': 'SYP',
		'America/Grand_Turk': 'USD',
		'Africa/Ndjamena': 'XAF',
		'Africa/Lome': 'XOF',
		'Asia/Bangkok': 'THB',
		'Asia/Dushanbe': 'TJS',
		'Pacific/Fakaofo': 'NZD',
		'Asia/Ashgabat': 'TMT',
		'Asia/Dili': 'USD',
		'Pacific/Tongatapu': 'TOP',
		'America/Port_of_Spain': 'TTD',
		'Africa/Tunis': 'TND',
		'Europe/Istanbul': 'TRY',
		'Pacific/Funafuti': 'AUD',
		'Asia/Taipei': 'TWD',
		'Africa/Dar_es_Salaam': 'TZS',
		'Africa/Kampala': 'UGX',
		'Europe/Kiev': 'UAH',
		'Europe/Simferopol': 'UAH',
		'Europe/Uzhgorod': 'UAH',
		'Europe/Zaporozhye': 'UAH',
		'Pacific/Midway': 'USD',
		'Pacific/Wake': 'USD',
		'America/Montevideo': 'UYI',
		'America/Adak': 'USD',
		'America/Anchorage': 'USD',
		'America/Boise': 'USD',
		'America/Chicago': 'USD',
		'America/Denver': 'USD',
		'America/Detroit': 'USD',
		'America/Indiana/Indianapolis': 'USD',
		'America/Indiana/Knox': 'USD',
		'America/Indiana/Marengo': 'USD',
		'America/Indiana/Petersburg': 'USD',
		'America/Indiana/Tell_City': 'USD',
		'America/Indiana/Vevay': 'USD',
		'America/Indiana/Vincennes': 'USD',
		'America/Indiana/Winamac': 'USD',
		'America/Juneau': 'USD',
		'America/Kentucky/Louisville': 'USD',
		'America/Kentucky/Monticello': 'USD',
		'America/Los_Angeles': 'USD',
		'America/Menominee': 'USD',
		'America/Metlakatla': 'USD',
		'America/New_York': 'USD',
		'America/Nome': 'USD',
		'America/North_Dakota/Beulah': 'USD',
		'America/North_Dakota/Center': 'USD',
		'America/North_Dakota/New_Salem': 'USD',
		'America/Phoenix': 'USD',
		'America/Sitka': 'USD',
		'America/Yakutat': 'USD',
		'Pacific/Honolulu': 'USD',
		'Asia/Samarkand': 'UZS',
		'Asia/Tashkent': 'UZS',
		'Europe/Vatican': 'EUR',
		'America/St_Vincent': 'XCD',
		'America/Caracas': 'VES',
		'America/Tortola': 'USD',
		'America/St_Thomas': 'USD',
		'Asia/Ho_Chi_Minh': 'VND',
		'Pacific/Efate': 'VUV',
		'Pacific/Wallis': 'XPF',
		'Pacific/Apia': 'WST',
		'Asia/Aden': 'YER',
		'Africa/Johannesburg': 'ZAR',
		'Africa/Lusaka': 'ZMW',
		'Africa/Harare': 'ZWL'
	}

	const dispatch = useDispatch()
	const {
		language,
		currency,
		timezone,
		firstTime
	} = useSelector(state => state.SettingsReducer)
	useEffect(() => {
		dispatch(SettingsAction.currencyFetch())
		dispatch(SettingsAction.timezonesFetch())
	}, [])

	useEffect(() => {
		if (!firstTime) {
			return
		}
		dispatch(SettingsAction.setFirstTime())

		const timezone = jstz.determine()

		dispatch(SettingsAction.setTimezone(timezone.name()))
		dispatch(SettingsAction.setLanguage('en'))
		dispatch(SettingsAction.setCurrency(ttc[timezone.name()]))

		if (timezone.name() === 'Asia/Tehran') {
			dispatch(SettingsAction.setLanguage('fa'))
			dispatch(SettingsAction.setCurrency('Rial'))
		}
	}, [])

	const classes = useStyles()
	const [openLanguageModal, setOpenLanguageModal] = React.useState(false)
	const [openCurrencyModal, setOpenCurrencyModal] = React.useState(false)
	const [openTimezoneModal, setOpenTimezoneModal] = React.useState(false)
	// const [drawer,setDrawer]=useState(false)

	const handleOpenLanguageModal = () => {
		setOpenLanguageModal(true)
	}

	const handleCloseLanguageModal = () => {
		setOpenLanguageModal(false)
	}
	const handleOpenCurrencyModal = () => {
		setOpenCurrencyModal(true)
	}

	const handleCloseCurrencyModal = () => {
		setOpenCurrencyModal(false)
	}
	const handleOpenTimezoneModal = () => {
		setOpenTimezoneModal(true)
	}

	const handleCloseTimezoneModal = () => {
		setOpenTimezoneModal(false)
	}

	const languageModalBody = (
		<div className={classes.paper}>
			<LanguageModalCard handleClose={handleCloseLanguageModal}/>
		</div>
	)
	const currencyModalBody = (
		<div className={classes.paper}>
			<CurrencyModalCard handleClose={handleCloseCurrencyModal}/>
		</div>
	)
	const timezoneModalBody = (
		<div className={classes.paper}>
			<TimezoneModalCard handleClose={handleCloseTimezoneModal}/>
		</div>
	)

	return (
		<Container className={classes.root} maxWidth="md">
			<div className={classes.header}>
				<H1>{I18n.t('settings.title')}</H1>
				<H4>{I18n.t('settings.description')}</H4>
			</div>
			<div>
				<Grid container justify="center">
					<Grid md={12} xs={12} item>
						<Grid container spacing={3}>

							<Grid item xs={12} md={6}>
								<div ref={rightBox}>

									<div onClick={handleOpenTimezoneModal}>
										<SettingsCard
											value={timezone}
											title={I18n.t('settings.timezoneTitle')}
											category={timezone}
											description={I18n.t('settings.timezoneDescription')}/>
									</div>

									<div style={{ height: 20 }}/>

									<div onClick={handleOpenCurrencyModal}>
										<SettingsCard
											value={currency === 'Rial' ? I18n.t(`settings.currencyTitleValue.${currency}`) : currency}
											title={I18n.t('settings.currencyTitle')}
											category={currency}
											description={I18n.t('settings.currencyDescription')}/>
									</div>
								</div>

							</Grid>
							<Grid item xs={12} md={6} onClick={handleOpenLanguageModal}>
								<SettingsCard
									value={I18n.t('settings.languageTitleRight')}
									title={I18n.t('settings.languageTitle')}
									category={language}
									description={I18n.t('settings.languageDescription')}
									style={{ height: isWidthUp('md', props.width) ? rightBox.current.offsetHeight : 'inherit' }}
								/>
							</Grid>
						</Grid>

					</Grid>
				</Grid>
				<Hidden mdUp>
					<Drawer anchor={'bottom'} open={openCurrencyModal} onClose={handleCloseCurrencyModal}>
						{currencyModalBody}
					</Drawer>
				</Hidden>
				<Hidden mdUp>
					<Drawer anchor={'bottom'} open={openLanguageModal} onClose={handleCloseLanguageModal}>
						{languageModalBody}
					</Drawer>
				</Hidden>
				<Hidden mdUp>
					<Drawer anchor={'bottom'} open={openTimezoneModal} onClose={handleCloseTimezoneModal}>
						{timezoneModalBody}
					</Drawer>
				</Hidden>

				<Hidden mdDown>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal}
						open={openCurrencyModal}
						onClose={handleCloseCurrencyModal}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500
						}}
					>
						{currencyModalBody}
					</Modal>
				</Hidden>
				<Hidden mdDown>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal}
						open={openLanguageModal}
						onClose={handleCloseLanguageModal}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500
						}}
					>
						{languageModalBody}
					</Modal>
				</Hidden>


				<Hidden mdDown>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal}
						open={openTimezoneModal}
						onClose={handleCloseTimezoneModal}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500
						}}
					>
						{timezoneModalBody}
					</Modal>
				</Hidden>
			</div>
			<div>
				<Grid container justify='center' className={classes.bottom}>
					<Grid item xs={12} md={6} onClick={() => {
						dispatch(SettingsAction.startButton())
					}}>
						<Button
							type="submit"
							variant="contained"
							color="primary"
							style={{
								boxShadow: '0px 4px 10px #009CDE5C',
								textTransform: 'none',
								borderRadius: 14,
								backgroundColor: '#009CDE',
								fontSize: '16px',
								fontFamily: 'Shabnam',
								width: '100%',
								marginBottom: 20,
								paddingTop: 10,
								paddingBottom: 10
							}}
						>{I18n.t('settings.button')}</Button>
					</Grid>
				</Grid>
			</div>
		</Container>
	)
}

export default withWidth()(SettingsScreen)
